<template>
  <div>TrangTaoDanhMucMenuHeThong</div>
</template>

<script>
export default {
  name: "TrangTaoDanhMucMenuHeThong"
};
</script>


